import { ValidationSchema } from '../../../../../../@types/validation-types'
import {
  defaultContactInfo,
  useManualAndInternationalAddress,
} from '../../../../../../services/validation/flow/defaultSchemas'
import { validationRules } from '../../../../../../services/validation/rules/validationRules'

export const tenantApartmentRentSchema: ValidationSchema = {
  address: useManualAndInternationalAddress,
  costs: {
    additionalCosts: validationRules.additionalCosts,
    deposit: validationRules.deposit,
    heatingCosts: validationRules.heatingCosts,
  },
  basicInfo: {
    livingSpace: validationRules.livingSpace,
    room: validationRules.room,
    price: validationRules.price,
  },
  description: {
    adTitle: validationRules.adTitle,
    adDescription: validationRules.adDescription,
    adLocation: validationRules.adLocation,
  },
  contactInfo: defaultContactInfo,
  otherFacilities: {
    noBathrooms: validationRules.noBathrooms,
    noBedrooms: validationRules.noBedrooms,
    floor: validationRules.floor,
    totalFloorsNumber: validationRules.totalFloorsWithDependingFloorNumber,
    usableArea: validationRules.usableArea,
    parkingSpaceRent: validationRules.parkingSpaceRent,
    noParkingSpaces: validationRules.noParkingSpaces,
  },
}
